import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  FETCH_GENERIC_DATA_REQUEST,
  FETCH_GENERIC_DATA_SUCCESS,
  FETCH_GENERIC_DATA_FAILURE,
  INVALIDATE_GENERIC_DATA,
} from '../reducers/GenericDataReducer';
import getGeneric from '../actions/getGeneric';
import { parseFilters } from '../containers/Filters/utils/fetchData';
import get from 'lodash/get';
const DEFAULT_EMPTY_CONFIG = {};

const useGenericDataWithAppliedFilters = ({
  id,
  data_tag,
  widget_config = DEFAULT_EMPTY_CONFIG,
  tempFilters = DEFAULT_EMPTY_CONFIG,
  apiResponseKey,
  skip = false
}) => {
  const dispatch = useDispatch();

  const genericData = useSelector((state) => get(state, `genericData.${id}`, null));
  const appliedFilterValues = useSelector((state) => get(state, 'filterReducer.applied_filter_values', {}));

  const fetchData = useCallback(() => {
    if (skip || Object.keys(appliedFilterValues).length === 0) {
      return;
    }

    const { filters, benchmark } = parseFilters(appliedFilterValues);
    dispatch({ type: FETCH_GENERIC_DATA_REQUEST, payload: { id } });
    const payload = {
      requestBody: {
        data_tag,
        request_data: {
          widget_id: id,
          filters,
          benchmark,
          widget_config,
          ...tempFilters
        }
      },
      onSuccess: (response) => {
        const apiResponseObj = get(response, `api_response.${apiResponseKey}`, {});
        if (apiResponseObj?.data) {
          dispatch({
            type: FETCH_GENERIC_DATA_SUCCESS,
            payload: { id, data: apiResponseObj.data }
          });
        }
        else {
          dispatch({
            type: FETCH_GENERIC_DATA_FAILURE,
            payload: { id, isError: true, error: { message: "API Response Success False" } }
          });
        }
      },
      onError: (error) => {
        dispatch({
          type: FETCH_GENERIC_DATA_FAILURE,
          payload: { id, isError: true, error }
        });
      }
    };

    dispatch(getGeneric(payload));
  }, [dispatch, id, data_tag, widget_config, tempFilters, appliedFilterValues, apiResponseKey, skip]);

  useEffect(() => {
    const hasData = get(genericData, 'data', null);
    const hasError = get(genericData, 'isError', false) || get(genericData, 'error', null);

    if ((!hasData || hasError) && !skip) {
      fetchData();
    }
  }, [fetchData, skip]);

  const invalidate = () => {
    dispatch({ type: INVALIDATE_GENERIC_DATA, payload: { id } });
  }

  return {
    data: get(genericData, "data", null),
    loading: get(genericData, "loading", false),
    error: get(genericData, "error", null),
    isError: get(genericData, "isError", false),
    invalidate,
    fetchData
  };
};

export default useGenericDataWithAppliedFilters;
